import React, { useEffect, useState } from 'react';
import Pagination from './StudyDestination/Australia/Pagination';
import { Link } from 'react-router-dom';
import ImageWithBasePath from '../core/common/imageWithBasePath';
import { all_routes } from './router/all_routes';
import { useGetStudyDestinationCountryTopUniversityApiQuery } from '../core/Features/api/studyDestination/StudyDestination';

interface BannerProps {
    apiValues2: any;
    extraData:any
}



const Whatsnew: React.FC<BannerProps> = ({ apiValues2,extraData }) => {

    const route = all_routes;

    const [page, setPage] = useState(1);
    const limit = 3; // item per page
    const { data: apiValues, isLoading, isError } = useGetStudyDestinationCountryTopUniversityApiQuery({ page, limit, id: apiValues2 });

    const universities = apiValues?.data || [];
    const totalItems = apiValues?.totalItems || 0; // Total count from backend
    const totalPages = Math.ceil(apiValues?.totalPages)
    //  Math.ceil(totalItems / limit);

    const [selectedItems, setSelectedItems] = useState<boolean[]>([]);

    useEffect(() => {
        if (universities.length) {
            setSelectedItems(Array(universities.length).fill(false));
        }
    }, [universities]);

    const handleItemClick = (index: number) => {
        setSelectedItems((prev) => {
            const updated = [...prev];
            updated[index] = !updated[index];
            return updated;
        });
    };

    if (isLoading) return <div className="text-center py-5">Loading...</div>;
    if (isError) return <div className="text-center text-danger">Failed to load data</div>;

    return (
        <div className="feature-section position-relative">
            <div className="container">
                {/* Section header */}
                <div className="section-header text-center">
                    <span className="section-badge">{extraData?.universitieTitle}</span>
                    <h2>{extraData?.universitiesDescription}</h2>
                    <p>{extraData?.universitiesMiniDescription}</p>
                </div>

                {/* University cards */}
                <div className="row mt-4">
                    {/* {universities.map((univ: any, index: number) => ( */}

                    {

                        (Array.isArray(universities) ? universities : []).map((univ: any, index: number) => {

                            return (

                                <div className="col-md-4 item" key={univ._id || index}>
                                    <div className="course-item-two course-item">
                                            <div className="h-32 w-full"
                                            style={{
                                                backgroundImage:`url(${univ.imageUrl})`,
                                                backgroundRepeat:"no-repeat",
                                                backgroundSize:"100% 100%"
                                            }}
                                        >
                                            {/* <Link to={route.courseDetails}> */}
                                                {/* <ImageWithBasePath source={univ.imageUrl} alt="university" className="img-fluid" /> */}
                                            {/* </Link> */}
                                            {/* <div className="position-absolute start-0 top-0 d-flex align-items-start w-100 z-index-2 p-2">
                                                <Link
                                                    to="#"
                                                    className={`fav-icon ${selectedItems[index] ? 'selected' : ''}`}
                                                    onClick={() => handleItemClick(index)}
                                                >
                                                    <i className="isax isax-heart" />
                                                </Link>
                                            </div> */}
                                        </div>

                                        <div className="course-content">
                                            <div className="ms-2">
                                                <h5 className="subs-title mb-3">{univ?.title}</h5>
                                                <p className="mb-2">{univ?.parentId?.countryName}</p>
                                            </div>
                                        </div>

                                        <div className="border-bottom w-100 mb-3" />
                                        {
                                            (Array.isArray(univ?.pointsDescription) ? univ?.pointsDescription : []).map((item: any, index: number) => {

                                                return (
                                                        <p className="flex items-center gap-1 !mb-2">
                                                        <ImageWithBasePath
                                                            className="me-2 w-8 h-8"
                                                            source={item?.iconUrl}
                                                            alt="img"
                                                        />
                                                        {item?.title}
                                                    </p>
                                                )
                                            }) || []
                                        }


                                       

                                        <div className="d-flex align-items-center justify-content-center p-3">
                                            <Link
                                                to={`${route.individualUniversity}/${univ._id}`}
                                                className="btn btn-danger btn-sm d-inline-flex align-items-center justify-content-center text-center"
                                                style={{ width: '200px', padding: '10px' }}
                                            >
                                                View Details
                                            </Link>
                                        </div>
                                    </div>
                                </div>

                            )

                        }) || []

                    }
                </div>

                {/* Pagination */}
                <Pagination currentPage={page} totalPages={totalPages} onPageChange={setPage} />
            </div>
        </div>
    );
};

export default Whatsnew;
